import type { FaireAdPerformancePeriodEntity } from "../../entity_types/adPerformancePeriod";

export const perfP6ChurnedOvw202601: FaireAdPerformancePeriodEntity = {
  token: "perf_p6_churned_ovw_202601",
  type: "adPerformancePeriod",
  scope: "OVERVIEW",
  periodType: "RECEIPT",
  startDate: "2026-01-01",
  endDate: "2026-01-31",
  impressions: 71207,
  clicks: 1256,
  adsSpendDollars: 4120,
  budgetDollars: 4400,
  salesDollars: 15683,
  bestEstimateRoas: 3.81,
  bestEstimateType: "ACTUALIZED",
  budgetUtilization: 0.94,
  newCustomersAcquired: 24,
  reorderConversions: 8,
  dataAvailableAtDate: "2026-02-04",
  meta: {
    source: "mock",
    importedAt: "2026-07-06T00:00:00.000Z",
    importedBy: "advertiser-profiles",
  },
};
